import { render, staticRenderFns } from "./BondPoliciesMOM.vue?vue&type=template&id=5f3d6dd6&"
import script from "./BondPoliciesMOM.vue?vue&type=script&lang=js&"
export * from "./BondPoliciesMOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports